// extracted by mini-css-extract-plugin
export default {"createNewOffer":"styles_createNewOffer__Qc4W8"};